import Layout from "../../../components/org/Layout";
import { Subdomain } from "../../../utils/subdomain/subdomain";
import { Link, Typography, Container } from "@mui/material";
import { InternalLink } from "../../../components/common/Link";
import { index } from "../../../routes/org";

const subdomain = "jesenickysnek" as Subdomain;

export default () => {
    return (
        <Layout
            subdomain={subdomain}
            seo={{ title: "Kontakty - Jesenický šnek" }}
        >
            <Container maxWidth={"md"}>
                <Typography variant={"h4"} component={"h1"} gutterBottom>
                    Kontakty
                </Typography>

                <dl>
                    <dt>
                        <Typography variant={"subtitle1"} fontWeight={"bold"}>
                            Kamil Osladil
                        </Typography>
                    </dt>
                    <dd>
                        vedoucí seriálu JŠ, web, výsledky, FB
                        <br />
                        <Link href={"tel:603875218"}>603 875 218</Link>
                        <br />
                        <Link href={"mailto:kamil.osladil@seznam.cz"}>
                            kamil.osladil@seznam.cz
                        </Link>
                    </dd>
                    <dt>
                        <Typography variant={"subtitle1"} fontWeight={"bold"}>
                            Rostislav Brokeš
                        </Typography>
                    </dt>
                    <dd>
                        vedoucí silnice JŠ
                        <br />
                        <Link href={"tel:778766192"}>778 766 192</Link>
                        <br />
                        <Link href={"mailto:brokes@gymjes.cz"}>
                            brokes@gymjes.cz
                        </Link>
                    </dd>

                    <dt>
                        <Typography variant={"subtitle1"} fontWeight={"bold"}>
                            Ladislav Chmelař
                        </Typography>
                    </dt>
                    <dd>
                        vedoucí MTB JŠ
                        <br />
                        <Link href={"tel:777496876"}>777 496 876</Link>
                        <br />
                        <Link href={"mailto:ladikcmelda@seznam.cz"}>
                            ladikcmelda@seznam.cz
                        </Link>
                    </dd>

                    <dt>
                        <Typography variant={"subtitle1"} fontWeight={"bold"}>
                            Patrik Pompe
                        </Typography>
                    </dt>
                    <dd>
                        web, výsledky
                        <br />
                        <Link href={"mailto:hello@xathlo.com"}>
                            hello@xathlo.com
                        </Link>
                    </dd>

                    <dt>
                        <Typography variant={"subtitle1"} fontWeight={"bold"}>
                            Pořadatel
                        </Typography>
                    </dt>
                    <dd>
                        <InternalLink
                            href={index.route({
                                subdomain,
                            })}
                        >
                            <Link>Jesenický šnek z.s.</Link>
                        </InternalLink>
                        <br />
                        Průchodní 149/2, 790 01 Jeseník
                        <br />
                        IČ: 266 18 923
                        <br />
                        Bankovní účet: 221004558/0300
                    </dd>
                </dl>
            </Container>
        </Layout>
    );
};
